export default "__VITE_ASSET__CNT8NsUW__"